import { render } from "./QuizCard.vue?vue&type=template&id=3db4aa32&scoped=true"
const script = {}

import "./QuizCard.vue?vue&type=style&index=0&id=3db4aa32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db4aa32"]])

export default __exports__